class Tabs {
    constructor (el) {
        this.el = el
        this.index = 0
        this.isModuleElement = this.isModuleElement.bind(this)
        this.tabsLinks = Array.from(this.el.querySelectorAll('[data-tab-link]')).filter(this.isModuleElement)
        this.tabs = Array.from(this.el.querySelectorAll('[data-tab]')).filter(this.isModuleElement)
        this.displaySelected = this.displaySelected.bind(this)

        const preselect_elem =  this.el.querySelector('[data-tab-preselect]')
        if (preselect_elem && this.isModuleElement(preselect_elem)) {
            this.index = this.getIndex(preselect_elem, this.tabs)
        }

        if (this.tabs.length > 0 && this.tabsLinks.length > 0) {
            this.init()
        }
    }

    init () {
        this.displaySelected()
        this.tabsLinks.forEach((s) => s.addEventListener('click', this.displaySelected))
    }

    displaySelected (e = null) {
        if (e) {
            e.preventDefault()
            this.index = e.currentTarget.dataset.tabLink ? parseInt(e.currentTarget.dataset.tabLink) : this.getIndex(e.currentTarget, this.tabsLinks)
        }
        this.showTab(this.index)
    }

    showTab (index) {
        if (parseInt(this.tabs[index].dataset.tab) >= 0) {
            this.tabs.forEach((el) => {
                el.classList[parseInt(el.dataset.tab) === index ? 'add' : 'remove']('-active')
            })
        } else {
            this.tabs.forEach((el, i) => el.classList[i === index ? 'add' : 'remove']('-active'))
        }
        this.tabsLinks.filter(el => !el.dataset.tabLink).forEach((el, i) => el.classList[i === index ? 'add' : 'remove']('-active'))
        this.tabsLinks.filter(el => el.dataset.tabLink).forEach((el) => el.classList[parseInt(el.dataset.tabLink) === index ? 'add' : 'remove']('-active'))
        document.dispatchEvent(new Event('tab_changed'))
    }

    getIndex (el, els) {
        const index = els.filter(el => !el.dataset.tabLink).findIndex(e => e === el)
        return index > 0 ? index : 0
    }

    isModuleElement (el) {
        return el.closest('[data-module="tabs"]') === this.el
    }
}

export default Tabs